import styled from "styled-components";

export const HelperTextContainer = styled.p`
  color: #dc3545;
  margin: 0;
`;
